export const selectDailyTasksData = (state) => state.scheduler.tasks;
export const selectDailyTasksToSync = (state) => state.scheduler.tasksToSync;
export const selectDailyTasksToDelete = (state) => state.scheduler.tasksToDelete;
export const selectTasksLastSyncDate = (state) => state.scheduler.lastSync;
